import * as actionTypes from './actionTypes';

export const createCase = newCase => ({
  type: actionTypes.CREATE_CASE,
  newCase
})

export const updateTempRefInCase = (caseId, tempRefId) => ({
  type: actionTypes.UPDATE_CASE_WITH_TEMPREF,
  caseId,
  tempRefId
})

export const updateCase = (caseId, productType, productData) => ({
  type: actionTypes.UPDATE_CASE,
  caseId,
  productType,
  productData
})

export const updateEntityName = (entityId, entityName) => ({
  type:actionTypes.UPDATE_ENTITY_NAME,
  entityId,
  entityName
})

export const updateCaseEntityName = (caseId, entityName) => ({
  type: actionTypes.UPDATE_CASE_ENTITY_NAME,
  caseId,
  entityName
})

export const deleteProduct = (caseId, productType, productId) => ({
  type: actionTypes.DELETE_PRODUCT_FROM_CASE,
  caseId,
  productType,
  productId
})

export const deleteCase = caseId => ({
  type: actionTypes.DELETE_CASE,
  caseId
})

export const setCases = (cases, entities) => ({
  type: actionTypes.SET_CASES,
  cases,
  entities
})

export const updateCasesWithStatus = caseStatuses => ({
  type: actionTypes.UPDATE_CASE_STATUSES,
  caseStatuses
})

export const createEntity = newEntity => ({
  type: actionTypes.CREATE_ENTITY,
  newEntity
})

export const updateEntity = (entityId, entityData) => ({
  type: actionTypes.UPDATE_ENTITY,
  entityId,
  entityData
})

export const updateEntityStatus = (entityId, caseStatus) => ({
  type: actionTypes.UPDATE_ENTITY_STATUS,
  entityId,
  caseStatus
})

export const setEntityToNoConflictStatus = entityId => ({
  type: actionTypes.SET_ENTITY_TO_NO_CONFLICT_STATE,
  entityId
})

export const updateEntityWithCaseId = (entityId, caseId) => ({
  type: actionTypes.UPDATE_ENTITY_WITH_CASEID,
  entityId,
  caseId
})

export const deleteEntity = entityId => ({
  type: actionTypes.DELETE_ENTITY,
  entityId
})

export const setEntities = (entities, cases) => ({
  type: actionTypes.SET_ENTITIES,
  entities,
  cases
})

export const setCountryInfo = countryInfo => ({
  type: actionTypes.SET_COUNTRY_INFO,
  countryInfo
})

export const setCountryInfoData = countryInfoData => ({
  type: actionTypes.SET_COUNTRY_INFO_DATA,
  countryInfoData
})

export const setBankNameInfo = bankNameInfo => ({
  type: actionTypes.SET_BANKNAME_INFO,
  bankNameInfo
})


export const setCurrencyInfo = currencyInfo => ({
  type: actionTypes.SET_CURRENCY_INFO,
  currencyInfo
})

export const resetCountryInfo = () => ({
  type: actionTypes.RESET_COUNTRYINFO_DROPDOWN
})

export const resetCurrencyInfo = () => ({
  type: actionTypes.RESET_CURRENCYINFO_DROPDOWN
})

export const newEntities = entities => ({
  type: actionTypes.NEW_ENTITIES,
  entities
})

export const oldEntities = entities => ({
  type: actionTypes.OLD_ENTITIES,
  entities
})

export const setAccountPaperStatement = accountPaperStatement => ({
  type: actionTypes.SET_ACCOUNT_PAPERSTATEMENT,
  accountPaperStatement
})

export const resetAccountPaperStatement = () => ({
  type: actionTypes.RESET_ACCOUNT_PAPERSTATEMENT
})



// WEBPACK FOOTER //
// ./src/components/createAcase/actions/actionCreator.js